import api from '../../api'

const recurrenceAPI = api.create('recurrence')

const create = async ({ contractId, ...data }) => {
  return await recurrenceAPI.post(
    `contracts/${contractId}/contract_plans`,
    data,
  )
}

const update = async ({ contractId, contractPlanId, ...data }) => {
  return await recurrenceAPI.put(
    `contracts/${contractId}/contract_plans/${contractPlanId}`,
    data,
  )
}

const inactivate = async ({ contractPlanId }) => {
  return await recurrenceAPI.delete(`/contract_plans/${contractPlanId}`)
}

const get = async ({ contractPlanId }) => {
  return await recurrenceAPI.get(`/contract_plans/${contractPlanId}`)
}

export default {
  get,
  create,
  update,
  inactivate,
}
